import React from 'react';

const AnalyticsDiv = ({ tag, onClick, children, className, ...props }) => {
  const handleButtonClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };
  return (
    <div className={className} onClick={(e) => handleButtonClick(e)} {...props}>
      {children}
    </div>
  );
};

export default AnalyticsDiv;
